import { render } from "./InterviewRecordings.vue?vue&type=template&id=85620fec&scoped=true"
import script from "./InterviewRecordings.vue?vue&type=script&lang=js"
export * from "./InterviewRecordings.vue?vue&type=script&lang=js"

import "./InterviewRecordings.vue?vue&type=style&index=0&id=85620fec&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85620fec"]])

export default __exports__